import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { SwalComponent } from '@sweetalert2/ngx-sweetalert2';
import { TypeLogin } from 'src/app/enums/type-login';
import { Container } from 'src/app/models/container';
import { DbAdminUserProvider } from 'src/app/providers/database/db-admin-user';
import { DbEventsProvider } from 'src/app/providers/database/db.events';
import { Event } from 'src/app/models/event';

@Component({
  selector: 'app-default-container',
  templateUrl: './default-container.component.html',
  styleUrls: ['./default-container.component.scss']
})
export class DefaultContainerComponent implements OnInit {
  @ViewChild('successSwal') public successSwal: SwalComponent;
  @ViewChild('errorSwal') public errorSwal: SwalComponent;
  @ViewChild('warningSwal') public warningSwal: SwalComponent;

  containerId: string = 'defaultContainer';
  loginType: TypeLogin = 0;
  clients: Array<any> = [];
  container: Container = {
    uid: 'defaultContainer',
    clientId: null,
    appName: null,
    loginPage: {
      type: TypeLogin.WITH_EMAIL_CONFIRM,
      eventId: null,
    },
    loginOptions: {
      fbLoginBtn: false,
      gLoginBtn: false,
      registeBtn: false,
      shortcodeBtn: true,
    },
    logo: null,
    login1stBackground: '',
    login2ndBackground: '',
    logoSize: 'invent-logo',
    color: null,
    termsOfUse: '',
    privacyTerms: '',
    login_btn_bg_color: '',
    login_btn_color: '',
    valid_btn_bg_color: '#ffffff',
    valid_btn_color: '#ffffff',
    text_color_1st_login: '#ffffff',
    text_color_2nd_login_desktop: '#201157',
    text_color_2nd_login_mobile: '#ffffff',
    label_login_color: '#908B99',
    color_blue_default: '#2973A2',
    color_blue_default_contrast: '#ffffff',
    color_blue_default_shade: '#2083c0',
    color_blue_default_tint: '#639EBC',
  };
  displaySelectEvent: boolean = false;
  keyword = 'name';
  eventLoader: boolean = false;
  saveLoader: boolean = false;
  events: Array<Event> = [];
  allowPublicOptions: boolean = false
  blankField: boolean = false;
  nameFile: string = null;
  firstImgBackgroundName: string = null;
  secondImgBackgroundName: string = null;
  displayImage: any = null;
  displayFirstImgBackground: any = null;
  displaySecondImgBackground: any = null;
  selectedEvent: Event = null;
  noEvents: boolean = false;
  blockBtnSave: boolean = false;

  firstBase64Picture =null;
  secondBase64Picture =null;
  constructor(
    private dbAdmin: DbAdminUserProvider,
    private dbEvents: DbEventsProvider,
    private zone: NgZone
  ) {
    ;
  }

  ngOnInit() {
    this.getContainer();
  }

  getContainer() {
    this.dbAdmin.getContainer(this.containerId, (container: Container) => {
      this.zone.run(() => {
        this.container = container;
      })
    });
  }
  // get image from input file
  getPicture($ev) {
    this.nameFile = $ev.target.value;
    this.displayImage = $ev.srcElement.files[0]
  }

  // get background images from input file
  getBackgrounds($ev, order) {
    const imageType = $ev.srcElement.files[0].type;
    const reader = new FileReader();
    reader.onload = (e) => {
      let imgType: string;

      if (imageType == 'image/gif') {
          imgType = 'data:image/gif;base64,';
      } else if (imageType == 'image/png') {
          imgType = 'data:image/png;base64,';
      } else if (imageType == 'image/jpg') {
          imgType = 'data:image/jpg;base64,';
      } else {
          imgType = 'data:image/jpeg;base64,';
      }
      if(order === '1st') this.firstBase64Picture = imgType + btoa(e.target.result.toString());
      else if(order === '2nd') this.secondBase64Picture = imgType + btoa(e.target.result.toString());
    };
    if(order === '1st') {
      this.firstImgBackgroundName = $ev.target.value;
      this.displayFirstImgBackground = $ev.srcElement.files[0]
      reader.readAsBinaryString(this.displayFirstImgBackground);
    }
    else if(order === '2nd'){
      this.secondImgBackgroundName = $ev.target.value;
      this.displaySecondImgBackground = $ev.srcElement.files[0]
      reader.readAsBinaryString(this.displaySecondImgBackground);
    }
  }

  changeLoginType(ev) {
    this.loginType = ev.target.value;
  }

  loginTypeEventChange() {
    this.events = [];
    this.eventLoader = false;
    this.blockBtnSave = false;
    this.displaySelectEvent = false;
    this.container.loginPage.eventId = null;
    this.allowPublicOptions = false;
    this.container.loginOptions.fbLoginBtn = false;
    this.container.loginOptions.gLoginBtn = false;
  }

  updateContainer() {
    this.blankField = false;
    if (this.container.appName !== null
      && this.container.loginPage.type !== null
      && (this.container.logo !== null || this.displayImage !== null)
      && (this.container.login1stBackground !== null || this.displayFirstImgBackground !== null)
      && (this.container.login2ndBackground !== null || this.displaySecondImgBackground !== null)
      && this.container.logoSize !== null
    ) {
      this.saveLoader = true;
      this.dbAdmin.updateContainer(this.container, this.displayImage,this.displayFirstImgBackground,this.displaySecondImgBackground, (status) => {
        if (status) {
          this.successSwal.fire();
          this.saveLoader = false;
        } else {
          this.errorSwal.fire();
          this.saveLoader = false;
        }
      })
    } else {
      this.blankField = true;
    }
  }

  reload() {
    this.getContainer();
    this.displayImage = null;
    this.nameFile = null;
    this.displayFirstImgBackground = this.displaySecondImgBackground = null;
    this.firstImgBackgroundName = this.secondImgBackgroundName = null;
  }

  async removeImage(type: string){
    const res = await this.warningSwal.fire()
    if(res.isDismissed){
      // console.log("bye")
      return
    }

    if(type === '1st' && (this.container.login1stBackground === '' || this.container.login1stBackground === null || this.container.login1stBackground === undefined)) {
      return;
    }
    if(type === '2nd' && (this.container.login2ndBackground === '' || this.container.login2ndBackground === null || this.container.login2ndBackground === undefined)) {
      return;
    }
    this.saveLoader = true;
    this.dbAdmin.removeBgImage(this.container, type, (status) => {
      if (status) {
        this.successSwal.fire();
        this.saveLoader = false;
      } else {
        this.errorSwal.fire();
        this.saveLoader = false;
      }
    })
  }

  attachFile(type) {
    document.getElementById(`login${type}Background`).click()
  }
}
